import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import api from "@api";
import "./LoggedInWall.css";

function LoggedInWall() {
  const navigate = useNavigate();

  const [profile, setProfile] = useState(null);
  useEffect(() => {
    const fetchProfile = async () => {
      try {

        const res = await api.get("/api/user-profiles-v2/me");
        console.log("Logged in profile:", res.data.profile);
        setProfile(res.data.profile);
      } catch (error) {
        console.error("Failed to load profile:", error);
      }
    };

    fetchProfile();
  }, []);
  const getInitials = (name = "") => {
    return name
      .trim()
      .split(/\s+/)
      .slice(0, 2)
      .map((part) => part[0])
      .join("")
      .toUpperCase();
  };

  const feedItems = [
    {
      id: 1,
      type: "verified_result",
      label: "VERIFIED RESULT",
      typeClass: "verified",
      createdAt: "2h",

      title: "Skidmarks beat Team Legacy 62–55",
      subtitle: "Tustin Columbus Gym League • Men's Basketball",
      detail: "Stan Chen: 18 PTS, 4 3PM, 6 REB",

      source: {
        type: "organization",
        id: 1,
        name: "Fast Action Basketball",
      },

      gameId: 3055,
      playerId: 2069,

      action: {
        label: "View Game",
        type: "game",
        id: 3055,
      },

      engagement: {
        likeCount: 12,
        commentCount: 3,
        likedByMe: false,
      },
    },

    {
      id: 2,
      type: "player_tagged",
      label: "YOU WERE TAGGED",
      typeClass: "tagged",
      createdAt: "3h",

      title: "Fast Action Basketball tagged you in a game",
      subtitle: "Stan Chen: 24 PTS vs Team Alpha",

      source: {
        type: "organization",
        id: 1,
        name: "Fast Action Basketball",
      },

      playerId: 2069,
      gameId: 3056,

      action: {
        label: "View Game",
        type: "game",
        id: 3056,
      },

      engagement: {
        likeCount: 8,
        commentCount: 1,
        likedByMe: false,
      },
    },

    {
      id: 3,
      type: "league_update",
      label: "LEAGUE UPDATE",
      typeClass: "league",
      createdAt: "5h",

      title: "Coach Anderson started a new Sunday basketball league",
      subtitle: "Sunday Hoops League • Santa Ana, CA",

      source: {
        type: "league",
        id: 15,
        name: "Sunday Hoops League",
      },

      leagueId: 15,

      action: {
        label: "View League",
        type: "league",
        id: 15,
      },

      engagement: {
        likeCount: 17,
        commentCount: 4,
        likedByMe: false,
      },
    },

    {
      id: 4,
      type: "player_moment",
      label: "PLAYER MOMENT",
      typeClass: "player",
      createdAt: "6h",

      title: "Mike Lee scored 28 points last night",
      subtitle: "Orange County Basketball",

      source: {
        type: "player",
        id: 103,
        name: "Mike Lee",
      },

      playerId: 103,

      action: {
        label: "View Player",
        type: "player",
        id: 103,
      },

      engagement: {
        likeCount: 21,
        commentCount: 6,
        likedByMe: false,
      },
    },

    {
      id: 5,
      type: "challenge",
      label: "CHALLENGE",
      typeClass: "challenge",
      createdAt: "8h",

      title: "Top Scorers This Week — Orange County",
      subtitle:
        "1. John Wayne — 34 PTS • 2. Stan Chen — 24 PTS • 3. Mike Lee — 22 PTS",

      source: {
        type: "challenge",
        id: 1,
        name: "Orange County Top Scorers",
      },

      action: {
        label: "View Challenge",
        type: "challenge",
        id: 1,
      },

      engagement: {
        likeCount: 31,
        commentCount: 9,
        likedByMe: false,
      },
    },
  ];




  if (!profile) {
    return null;
  }

  return (
    <div className="loggedInWall-page">
      <div className="loggedInWall-layout">

        <aside className="loggedInWall-sidebar">

          {/* My Profile */}
          <div
            className="loggedInWall-profile"
            onClick={() => navigate(`/profile/${profile.id}`)}
          >
            {profile.profile_image ? (
              <img
                src={profile.profile_image}
                alt={profile.display_name}
                className="loggedInWall-avatar-image"
              />
            ) : (
              <div className="loggedInWall-avatar">
                {getInitials(profile.display_name)}
              </div>
            )}

            <div className="loggedInWall-profile-info">
              <strong>{profile.display_name}</strong>
              <span>{profile.city}, {profile.state}</span>
              <small>View My Profile →</small>
            </div>
          </div>

          {/* Following
          <div className="loggedInWall-sidebar-section">
            <div className="loggedInWall-sidebar-heading">
              <div>
                <div className="loggedInWall-sidebar-title">
                  Following
                </div>

                <span className="loggedInWall-sidebar-subtitle">
                  Your sports world
                </span>
              </div>

              <span className="loggedInWall-following-count">
                {followingCount}
              </span>
            </div>

            <button>
              Players
              <span>{profile.following.players.length}</span>
            </button>

            <button>
              Teams
              <span>{profile.following.teams.length}</span>
            </button>

            <button>
              Leagues
              <span>{profile.following.leagues.length}</span>
            </button>

            <button>
              Organizations
              <span>{profile.following.organizations.length}</span>
            </button>
          </div> */}

        </aside>

        <main className="loggedInWall-main">

          <div className="loggedInWall-heading">
            <div>
              <h1>Your Wall</h1>
              <p>
                Updates from the players, teams, leagues, and sports you care about.
              </p>
            </div>
          </div>

          <div className="loggedInWall-tabs">
            <button className="active">For You</button>
            <button>Following</button>
            <button>Local</button>
          </div>

          <div className="loggedInWall-composer">

            {profile.profileImage ? (
              <img
                src={profile.profile_image}
                alt={profile.display_name}
                className="loggedInWall-composer-avatar-image"
              />
            ) : (
              <div className="loggedInWall-composer-avatar">
                {getInitials(profile.display_name)}
              </div>
            )}

            <div className="loggedInWall-composer-body">
              <button className="loggedInWall-composer-input">
                What&apos;s happening in your sports world?
              </button>

              <div className="loggedInWall-composer-actions">
                <button>Photo / Video</button>
                <button>Tag Player</button>
                <button>Report Score</button>
              </div>
            </div>
          </div>

          <div className="loggedInWall-feed">
            {feedItems.map((item) => (
              <article
                key={item.id}
                className="loggedInWall-card"
              >
                <div className="loggedInWall-card-header">
                  <span
                    className={`loggedInWall-card-type ${item.typeClass}`}
                  >
                    {item.label}
                  </span>

                  <span className="loggedInWall-card-time">
                    {item.createdAt}
                  </span>
                </div>

                <div className="loggedInWall-card-source">
                  {item.source.name}
                </div>

                <h2>{item.title}</h2>

                <p>{item.subtitle}</p>

                {item.detail && (
                  <div className="loggedInWall-card-detail">
                    {item.detail}
                  </div>
                )}

                <button className="loggedInWall-card-action">
                  {item.action.label}
                </button>

                <div className="loggedInWall-engagement">
                  <button>
                    ♡ {item.engagement.likeCount}
                  </button>

                  <button>
                    💬 {item.engagement.commentCount}
                  </button>
                </div>
              </article>
            ))}
          </div>

        </main>

      </div>
    </div>
  );
}

export default LoggedInWall;